/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Logs_PlaceholderInputs */

const en_search_logs_placeholder = /** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search logs or actors...`)
};

const es_search_logs_placeholder = /** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar registros o actores...`)
};

const fr_search_logs_placeholder = /** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des journaux ou des acteurs...`)
};

const de_search_logs_placeholder = /** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche nach Protokollen oder Akteuren...`)
};

const id_search_logs_placeholder = /** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari log atau aktor...`)
};

/** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */
const ja_search_logs_placeholder = en_search_logs_placeholder;

/** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */
const zh_search_logs_placeholder = en_search_logs_placeholder;

/** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */
const ar_search_logs_placeholder = en_search_logs_placeholder;

/** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */
const it_search_logs_placeholder = en_search_logs_placeholder;

/** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */
const ru_search_logs_placeholder = en_search_logs_placeholder;

/** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */
const pt_search_logs_placeholder = en_search_logs_placeholder;

/** @type {(inputs: Search_Logs_PlaceholderInputs) => LocalizedString} */
const ko_search_logs_placeholder = en_search_logs_placeholder;

/**
* | output |
* | --- |
* | "Search logs or actors..." |
*
* @param {Search_Logs_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_logs_placeholder = /** @type {((inputs?: Search_Logs_PlaceholderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Logs_PlaceholderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_logs_placeholder(inputs)
	if (locale === "es") return es_search_logs_placeholder(inputs)
	if (locale === "fr") return fr_search_logs_placeholder(inputs)
	if (locale === "de") return de_search_logs_placeholder(inputs)
	if (locale === "ja") return ja_search_logs_placeholder(inputs)
	if (locale === "zh") return zh_search_logs_placeholder(inputs)
	if (locale === "ar") return ar_search_logs_placeholder(inputs)
	if (locale === "id") return id_search_logs_placeholder(inputs)
	if (locale === "it") return it_search_logs_placeholder(inputs)
	if (locale === "ru") return ru_search_logs_placeholder(inputs)
	if (locale === "pt") return pt_search_logs_placeholder(inputs)
	return ko_search_logs_placeholder(inputs)
});